/**
 * Quick Add to Cart — Thin Bar
 * Event-delegated AJAX add-to-cart with Rebuy Smart Cart + District pub/sub.
 */
(function () {
  'use strict';

  /* ---- Rebuy Smart Cart ---- */
  function triggerRebuy() {
    try {
      document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
    } catch (_) { /* ignore */ }
    try {
      if (window.Rebuy && window.Rebuy.smartcart && typeof window.Rebuy.smartcart.show === 'function') {
        window.Rebuy.smartcart.show();
      }
    } catch (_) { /* ignore */ }
  }

  /* ---- Native cart notification fallback ---- */
  function triggerNativeCartNotification() {
    var el = document.querySelector('cart-notification') || document.querySelector('[id="cart-notification"]');
    if (el && typeof el.renderContents === 'function') {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function () {
          el.renderContents({
            ok: true,
            status: 200,
            json: function () {
              return fetch('/cart.js').then(function (r) { return r.json(); });
            }
          });
        });
    }
  }

  /* ---- Cart badge update (fixed selector: data-cart-button-count) ---- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-button-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.removeAttribute('hidden');
          }
        });
      })
      .catch(function () { /* silent */ });
  }

  /* ---- District pub/sub integration ---- */
  function publishCartUpdate(data) {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'quick-add',
        cartData: data
      });
    }
  }

  /* ---- Loading state helpers ---- */
  function setLoading(btn, loading) {
    if (loading) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  }

  /* ---- AJAX add to cart ---- */
  function addToCart(variantId, btn) {
    if (!variantId || btn.getAttribute('aria-busy') === 'true') return;

    var openDrawer = btn.getAttribute('data-qa-open-drawer') !== 'false';

    setLoading(btn, true);

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function (data) {
        setLoading(btn, false);
        publishCartUpdate(data);
        updateCartCount();

        if (openDrawer) {
          triggerRebuy();
          triggerNativeCartNotification();
        }
      })
      .catch(function (err) {
        console.warn('[Quick Add]', err.message);
        setLoading(btn, false);
      });
  }

  /* ---- Event delegation ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qa-variant-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = parseInt(btn.getAttribute('data-qa-variant-id'), 10);
    addToCart(variantId, btn);
  });

  // Keyboard support for non-button quick-add elements rendered inside links.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest('[data-qa-variant-id]');
    if (!btn) return;
    e.preventDefault();
    btn.click();
  });
})();
